module.exports = __webpack_public_path__ + "static/media/femaleIcon.e1797fdf.svg";